/* Revival Nutrition pre-order behavior (built for the Krown-based Catabox theme).
 *
 * Works with the data block printed by snippets/rn-preorder.liquid. Each variant is in one of:
 *   "preorder"  zero stock, continue selling on, ship date available
 *   "soldout"   zero stock, continue selling on, NO ship date available
 *   ""          normal
 *
 * preorder: button says "Pre-order now", note is shown, a line item property carries the
 *           ship date into checkout and the order, express checkout and subscription
 *           options are hidden (pre-orders are one-time purchases).
 * soldout:  main button AND the sticky bar button are disabled and say "Sold out".
 *
 * Optional overrides, set before this script loads:
 *   window.RN_PREORDER_CONFIG = { hideDynamicCheckout: false, hideSubscription: false, ... };
 */
(function () {
  'use strict';

  var DEFAULTS = {
    formSelector: 'form[data-type="add-to-cart-form"], form[action*="/cart/add"]',
    buttonSelector: '[data-js-product-add-to-cart], button[name="add"], button[type="submit"], input[type="submit"]',
    textSelector: '[data-js-product-add-to-cart-text]',
    stickyButtonSelector: 'sticky-add-to-cart button[data-js-atc]',
    variantSelector: '[name="id"]',
    dynamicCheckoutSelector: '.shopify-payment-button, .dynamic-checkout',
    stockPillSelector: '[data-js-variant-quantity]',
    subscriptionSelector: '.shopify_subscriptions_app_container',
    oneTimeRadioSelector: 'input[data-radio-type="one_time_purchase"]',
    hideDynamicCheckout: true,
    hideSubscription: true,
    pollMs: 500
  };

  function opt(key) {
    var cfg = window.RN_PREORDER_CONFIG || {};
    return cfg[key] != null ? cfg[key] : DEFAULTS[key];
  }

  function readText(holder) {
    return holder.tagName === 'INPUT' ? holder.value : holder.textContent.trim();
  }

  function writeText(holder, text) {
    if (holder.tagName === 'INPUT') {
      holder.value = text;
    } else {
      holder.textContent = text;
    }
  }

  // The element that actually holds the button words (often a <span> inside the <button>).
  function textHolder(button, preferredSelector) {
    if (button.tagName === 'INPUT') return button;
    if (preferredSelector) {
      var preferred = button.querySelector(preferredSelector);
      if (preferred) return preferred;
    }
    var leaves = Array.prototype.filter.call(button.querySelectorAll('*'), function (node) {
      return !node.children.length && node.textContent.trim();
    });
    return leaves.length ? leaves[0] : button;
  }

  function setStyle(el, prop, value) {
    if (el.style[prop] !== value) el.style[prop] = value;
  }

  function bind(dataEl) {
    if (dataEl.__rnBound) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!data || !data.variants) return;

    // The data block is printed once per page by the layout. Find the add to cart form
    // whose variant id belongs to this product (works on product pages and quick view).
    var form = null;
    var forms = document.querySelectorAll(opt('formSelector'));
    for (var i = 0; i < forms.length; i++) {
      var candidate = forms[i].querySelector(opt('variantSelector'));
      if (candidate && Object.prototype.hasOwnProperty.call(data.variants, String(candidate.value))) {
        form = forms[i];
        break;
      }
    }
    if (!form) return;
    var scope = form.closest('.shopify-section, .modal-content, main') || document;
    var button = form.querySelector(opt('buttonSelector')) || scope.querySelector(opt('buttonSelector'));
    if (!button) return;

    dataEl.__rnBound = true;

    // The note is printed next to the data block; move it under the buy button.
    var wrap = dataEl.closest('[data-rn-preorder-wrap]');
    var note = wrap && wrap.querySelector('[data-rn-preorder-note]');
    if (note) {
      var host = form.closest('product-form') || form;
      host.insertAdjacentElement('afterend', note);
      note.setAttribute('data-rn-placed', '');
    }
    var original = null;
    var stickyOriginal = null;
    var property = null;
    var weDisabled = false;
    var weAddedClass = false;
    var ticking = false;
    var observer = null;
    var timer = null;

    function ensureProperty() {
      if (property) return property;
      property = document.createElement('input');
      property.type = 'hidden';
      property.name = 'properties[' + data.propertyName + ']';
      property.value = data.propertyValue;
      property.disabled = true;
      form.appendChild(property);
      return property;
    }

    function isOurLabel(text) {
      return text === data.buttonLabel || text === data.soldOutLabel;
    }

    function currentState() {
      var idEl = form.querySelector(opt('variantSelector'));
      var id = idEl ? String(idEl.value) : '';
      return data.variants[id] || '';
    }

    function applyLabel(holder, state, which) {
      var text = readText(holder);
      var wanted = state === 'preorder' ? data.buttonLabel : state === 'soldout' ? data.soldOutLabel : null;
      var saved = which === 'sticky' ? stickyOriginal : original;

      // Remember the theme's own wording so we can put it back.
      if (text && !isOurLabel(text)) {
        saved = text;
        if (which === 'sticky') stickyOriginal = text; else original = text;
      }

      if (wanted) {
        if (text !== wanted) writeText(holder, wanted);
      } else if (isOurLabel(text) && saved) {
        writeText(holder, saved);
      }
    }

    function tick() {
      if (ticking) return;
      ticking = true;
      try {
        if (!document.body.contains(form)) {
          if (observer) observer.disconnect();
          if (timer) clearInterval(timer);
          dataEl.__rnBound = false;
          return;
        }

        var state = currentState();

        // Main button label.
        applyLabel(textHolder(button, opt('textSelector')), state, 'main');

        // Sticky bar button label (its click triggers the main button, so a disabled
        // main button already blocks it; this only fixes the words).
        var sticky = document.querySelector(opt('stickyButtonSelector'));
        if (sticky) {
          applyLabel(textHolder(sticky, '.button__text'), state, 'sticky');
          var stickyWantDisabled = state === 'soldout';
          if (sticky.disabled !== stickyWantDisabled) sticky.disabled = stickyWantDisabled;
        }

        // Sold out: disable the button. Only undo the disabling we did ourselves.
        if (state === 'soldout') {
          if (!button.disabled) {
            button.disabled = true;
            weDisabled = true;
          }
          if (!button.classList.contains('disabled')) {
            button.classList.add('disabled');
            weAddedClass = true;
          }
        } else {
          if (weDisabled) {
            if (button.disabled) button.disabled = false;
            weDisabled = false;
          }
          if (weAddedClass) {
            // The theme re-adds its own 'disabled' class when a variant really is unavailable.
            if (button.classList.contains('disabled')) button.classList.remove('disabled');
            weAddedClass = false;
          }
        }

        // Only write when something actually changes, so our own edits never
        // retrigger the MutationObserver in a loop.
        var prop = ensureProperty();
        if (prop.disabled !== (state !== 'preorder')) prop.disabled = state !== 'preorder';

        var flag = state || 'false';
        if (button.getAttribute('data-rn-preorder') !== flag) {
          button.setAttribute('data-rn-preorder', flag);
        }
        if (note && note.hidden !== (state !== 'preorder')) note.hidden = state !== 'preorder';

        // The theme's own "out of stock, but you can still order it" pill would contradict us.
        var pill = scope.querySelector(opt('stockPillSelector'));
        if (pill) setStyle(pill, 'display', state ? 'none' : '');

        if (opt('hideDynamicCheckout')) {
          var dynamic = scope.querySelectorAll(opt('dynamicCheckoutSelector'));
          Array.prototype.forEach.call(dynamic, function (el) {
            setStyle(el, 'display', state ? 'none' : '');
          });
        }

        // Pre-orders are one-time purchases: hide subscribe options and select one-time.
        if (opt('hideSubscription')) {
          var subs = scope.querySelector(opt('subscriptionSelector'));
          if (subs) {
            setStyle(subs, 'display', state ? 'none' : '');
            if (state) {
              var oneTime = subs.querySelector(opt('oneTimeRadioSelector'));
              if (oneTime && !oneTime.checked) oneTime.click();
            }
          }
        }
      } finally {
        ticking = false;
      }
    }

    // Safety net: never let a sold-out (no ship date) variant be submitted.
    form.addEventListener('submit', function (e) {
      if (currentState() === 'soldout') {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    form.addEventListener('change', tick);
    form.addEventListener('input', tick);

    // The theme announces variant changes; check right after, and once more after it repaints.
    document.addEventListener('VARIANT_CHANGE', function () {
      setTimeout(tick, 0);
      setTimeout(tick, 150);
    }, true);

    if (window.MutationObserver) {
      observer = new MutationObserver(tick);
      observer.observe(form, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    // Some paths swap the variant without events, so check on a slow interval too.
    timer = setInterval(tick, opt('pollMs'));

    tick();
  }

  function scan() {
    var els = document.querySelectorAll('[data-rn-preorder-data]');
    Array.prototype.forEach.call(els, bind);
  }

  var scanTimer = null;
  function scanSoon() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 200);
  }

  function start() {
    scan();
    // Re-bind when a section re-renders (theme editor, quick view, AJAX product swaps).
    document.addEventListener('shopify:section:load', scan);
    if (window.MutationObserver) {
      new MutationObserver(scanSoon).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
